import React from 'react';
import './AdminHeader.style.css';
import { Avatar, Badge, Button, Popover } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Breadcrumb, Content } from 'components';

const buttonStyle = {
  width: '100%',
  textAlign: 'left',
};

const PopoverContent = ({ onLogout }) => {
  return (
    <Content maxWidth={'100%'} padding={0}>
      <ul>
        <li>
          <Button
            type="text"
            danger
            icon={<LogoutOutlined />}
            style={{ ...buttonStyle }}
            onClick={() => onLogout()}
          >
            로그아웃
          </Button>
        </li>
      </ul>
    </Content>
  );
};

const AdminHeader = ({
  maxWidth,
  style,
  leftContent = [],
  rightContent = [],
  profile,
  count,
  size = 32,
  avatarStyle,
  onLogout,
}) => {
  /* ===== Render ===== */
  return (
    <div className="admin_header_layout" style={{ ...style }}>
      <div style={{ maxWidth: maxWidth }} className="admin_header_container">
        <div className="admin_breadcurmb">
          <Breadcrumb items={leftContent} separator={'>'} />
        </div>
        <div className="admin_info">
          <div style={{ marginRight: 16 }}>
            <Breadcrumb items={rightContent} style={{ fontSize: 16 }} />
          </div>
          <Popover
            content={<PopoverContent onLogout={onLogout} />}
            trigger={'click'}
            placement="bottom"
          >
            <Badge count={count}>
              <Avatar
                size={size}
                icon={<UserOutlined />}
                src={profile}
                style={{ background: '#EEEEEE', ...avatarStyle }}
              />
            </Badge>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
